import { useState } from 'react';
import { ROADMAP, type PhaseStatus } from '../lib/dna';

const statusTag: Record<PhaseStatus, string> = { done: 'st-completed', active: 'st-in_progress', planned: 'st-new' };
const statusLabel: Record<PhaseStatus, string> = { done: 'Complete', active: 'In progress', planned: 'Planned' };

export default function Roadmap() {
  const [phases, setPhases] = useState(ROADMAP);
  const toggle = (pi: number, mi: number) => setPhases((p) => p.map((ph, i) => i !== pi ? ph : { ...ph, milestones: ph.milestones.map((m, j) => j !== mi ? m : { ...m, done: !m.done }) }));

  const totalDone = phases.reduce((s, p) => s + p.milestones.filter((m) => m.done).length, 0);
  const total = phases.reduce((s, p) => s + p.milestones.length, 0);

  return (
    <>
      <div className="page-head">
        <div>
          <div className="page-title">Implementation Roadmap</div>
          <div className="page-sub">AI-First phased plan — data first, staff workflow second, AI copilots third, AI actions fourth. Human-in-the-loop.</div>
        </div>
        <span className="live-flag">{totalDone}/{total} milestones</span>
      </div>

      <div className="progress-line" style={{ height: 9, marginBottom: 20 }}><span style={{ width: `${Math.round((totalDone / total) * 100)}%` }} /></div>

      <div className="roadmap">
        {phases.map((p, pi) => {
          const done = p.milestones.filter((m) => m.done).length;
          return (
            <div className={`phase-card ph-${p.status}`} key={p.phase}>
              <div className="phase-head">
                <div>
                  <div className="phase-name">{p.phase}</div>
                  <div className="phase-goal">{p.goal}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <span className={`tag ${statusTag[p.status]}`}>{statusLabel[p.status]}</span>
                  <div className="phase-time">{p.timeline}</div>
                </div>
              </div>
              <div className="phase-prog">{done}/{p.milestones.length} done</div>
              <div className="mini-list">
                {p.milestones.map((m, mi) => (
                  <div className={`reminder-row${m.done ? ' done' : ''}`} key={mi} onClick={() => toggle(pi, mi)}>
                    <span className="rm-check">{m.done ? '✓' : ''}</span>
                    <div className="mr-main"><strong>{m.label}</strong></div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
